var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.924465 15.2462C-0.399744 16.0021 -0.276698 18.0177 1.1354 18.6036L9.35604 22.0313V28.084C9.35604 29.1445 10.2115 30 11.272 30C11.8404 30 12.3795 29.748 12.7427 29.3086L16.3755 24.9551L23.6352 27.9785C24.7426 28.4414 26.0258 27.7149 26.2075 26.5313L29.9575 2.15646C30.0688 1.44748 29.7582 0.73264 29.1664 0.328347C28.5746 -0.0759473 27.8012 -0.111103 27.1743 0.246316L0.924465 15.2462ZM3.97718 16.7403L23.9868 5.30878L11.1197 19.6876L11.19 19.7462L3.97718 16.7403ZM23.6118 24.9258L13.8501 20.8536L26.395 6.8322L23.6118 24.9258Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperPlane);
export default __webpack_public_path__ + "static/media/Paper Plane.e76764e59b4370a8478d770055a62726.svg";
export { ForwardRef as ReactComponent };